// LoginForm.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Spinner,
} from "reactstrap";

import imagenTransparente from "../../assets/images/PLAIN_BLANCO.png";
import imagenBackground from "../../assets/images/portada-tablet.png";

import { useAuth } from "../../AuthContext";
import medicGeekApi from "../../config/axiosConfig";
import { showErrorAlert, showLoginsAlert } from "./../../components/alerts";
import RestoreForm from "./restore";

const LoginForm = () => {
  const { login } = useAuth();

  const [formData, setFormData] = useState({
    user: "",
    userpass: "",
  });

  const [modal, setModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();

  const toggleModal = () => setModal(!modal);

  const handleChange = (e) => {
    const { id, value } = e.target;

    setFormData((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (loading) return;

    try {
      setLoading(true);

      const { user, userpass } = formData;

      if (!user || !userpass) {
        showErrorAlert("Por favor, ingrese usuario y contraseña");
        return;
      }

      if (user.trim() === "" || userpass.trim() === "") {
        showErrorAlert("Por favor, complete todos los campos");
        return;
      }

       //const response = await medicGeekApi.post(`/auth/login`, formData);
      const response = await medicGeekApi.post(`https://zaludapp.com/api/auth/login`, formData);

      const token = response.data.access_token;

      localStorage.setItem("token", token);

      login(token);

      showLoginsAlert("¡Bienvenido a Zalud Clinical!");

      navigate("/");
    } catch (error) {
      const errorMessage = error.response
        ? error.response.data.message
        : error.message;

      showErrorAlert(errorMessage);

      console.error("Error logging in:", errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div
        className="container-fluid overflow-hidden"
        style={{
          minHeight: "100vh",
          background:
            "linear-gradient(135deg, #0f172a 0%, #12213d 35%, #1f4fa3 100%)",
          position: "relative",
        }}
      >
        {/* ===== EFECTOS BACKGROUND ===== */}
        <div
          style={{
            position: "absolute",
            width: "450px",
            height: "450px",
            background: "rgba(90,169,255,0.18)",
            borderRadius: "50%",
            top: "-10%",
            left: "-10%",
            filter: "blur(90px)",
          }}
        ></div>

        <div
          style={{
            position: "absolute",
            width: "400px",
            height: "400px",
            background: "rgba(255,255,255,0.08)",
            borderRadius: "50%",
            bottom: "-10%",
            right: "-10%",
            filter: "blur(90px)",
          }}
        ></div>

        <div className="row min-vh-100 align-items-center justify-content-center position-relative">

          {/* ===== CARD LOGIN ===== */}
          <div className="col-12 col-xl-10">
            <div
              className="row overflow-hidden"
              style={{
                borderRadius: "32px",
                backdropFilter: "blur(18px)",
                background: "rgba(255,255,255,0.08)",
                border: "1px solid rgba(255,255,255,0.12)",
                boxShadow: "0 25px 60px rgba(0,0,0,0.35)",
              }}
            >

              {/* ===== LEFT SIDE ===== */}
              <div className="col-lg-7 d-none d-lg-block p-0 position-relative">

                <img
                  src={imagenBackground}
                  alt="background"
                  className="img-fluid w-100 h-100"
                  style={{
                    objectFit: "cover",
                    minHeight: "850px",
                    filter: "brightness(0.78)",
                  }}
                />

                {/* Overlay */}
                <div
                  style={{
                    position: "absolute",
                    inset: 0,
                    background:
                      "linear-gradient(to top, rgba(15,23,42,0.95), rgba(15,23,42,0.15))",
                  }}
                ></div>

                {/* Text */}
                <div
                  className="position-absolute text-white"
                  style={{
                    bottom: "4rem",
                    left: "4rem",
                    zIndex: 5,
                    maxWidth: "70%",
                  }}
                >
                  <div
                    style={{
                      background: "rgba(255,255,255,0.12)",
                      width: "fit-content",
                      padding: "0.5rem 1rem",
                      borderRadius: "999px",
                      marginBottom: "1.5rem",
                      backdropFilter: "blur(8px)",
                    }}
                  >
                    Plataforma Médica Inteligente
                  </div>

                  <h1
                    className="fw-bold"
                    style={{
                      fontSize: "3rem",
                      lineHeight: "1.2",
                    }}
                  >
                    Gestión clínica moderna y profesional
                  </h1>

                  <p
                    className="mt-3"
                    style={{
                      color: "rgba(255,255,255,0.75)",
                      fontSize: "1.05rem",
                    }}
                  >
                    Administra pacientes, consultas, pagos, recetas y citas
                    desde una plataforma elegante, rápida y segura.
                  </p>
                </div>
              </div>

              {/* ===== RIGHT SIDE ===== */}
              <div className="col-lg-5 col-12">

                <div
                  className="d-flex flex-column justify-content-center h-100 px-4 px-lg-5 py-5"
                  style={{
                    minHeight: "850px",
                  }}
                >

                  {/* ===== LOGO ===== */}
                  <div className="text-center mb-4">
                    <img
                      src={imagenTransparente}
                      alt="logo"
                      style={{
                        width: "300px",
                        objectFit: "contain",
                        filter: "drop-shadow(0px 10px 20px rgba(0,0,0,0.35))",
                      }}
                    />
                  </div>

                  {/* ===== TITULO ===== */}
                  <div className="text-center mb-5">
                    <h2
                      className="fw-bold text-white"
                      style={{
                        fontSize: "2rem",
                      }}
                    >
                      Bienvenido
                    </h2>

                    <p
                      style={{
                        color: "rgba(255,255,255,0.65)",
                        marginTop: "0.5rem",
                      }}
                    >
                      Accede a tu plataforma clínica premium
                    </p>
                  </div>

                  {/* ===== FORM ===== */}
                  <Form onSubmit={handleSubmit}>

                    {/* USER */}
                    <FormGroup className="mb-4">
                      <Label
                        className="text-white fw-semibold mb-2"
                      >
                        Usuario
                      </Label>

                      <div
                        className="d-flex align-items-center px-3"
                        style={{
                          height: "60px",
                          borderRadius: "18px",
                          background: "rgba(255,255,255,0.08)",
                          border: "1px solid rgba(255,255,255,0.12)",
                          backdropFilter: "blur(10px)",
                        }}
                      >
                        <i className="bi bi-person text-white fs-4 me-3"></i>

                        <Input
                          type="text"
                          id="user"
                          value={formData.user}
                          onChange={handleChange}
                          placeholder="Ingrese su usuario"
                          className="border-0 shadow-none text-white"
                          style={{
                            background: "transparent",
                          }}
                        />
                      </div>
                    </FormGroup>

                    {/* PASSWORD */}
                    <FormGroup className="mb-3">
                      <Label
                        className="text-white fw-semibold mb-2"
                      >
                        Contraseña
                      </Label>

                      <div
                        className="d-flex align-items-center px-3"
                        style={{
                          height: "60px",
                          borderRadius: "18px",
                          background: "rgba(255,255,255,0.08)",
                          border: "1px solid rgba(255,255,255,0.12)",
                          backdropFilter: "blur(10px)",
                        }}
                      >
                        <i className="bi bi-shield-lock text-white fs-4 me-3"></i>

                        <Input
                          type={showPassword ? "text" : "password"}
                          id="userpass"
                          value={formData.userpass}
                          onChange={handleChange}
                          placeholder="••••••••"
                          className="border-0 shadow-none text-white"
                          style={{
                            background: "transparent",
                          }}
                        />

                        <button
                          type="button"
                          onClick={() => setShowPassword(!showPassword)}
                          className="btn border-0"
                        >
                          <i
                            className={`bi ${
                              showPassword
                                ? "bi-eye-slash"
                                : "bi-eye"
                            } text-white`}
                          ></i>
                        </button>
                      </div>
                    </FormGroup>

                    {/* FORGOT */}
                    <div className="d-flex justify-content-end mb-4">
                      <button
                        type="button"
                        onClick={toggleModal}
                        className="btn border-0 p-0"
                        style={{
                          color: "#8ec5ff",
                          fontSize: "0.95rem",
                        }}
                      >
                        ¿Olvidaste tu contraseña?
                      </button>
                    </div>

                    {/* LOGIN BUTTON */}
                    <Button
                      type="submit"
                      disabled={loading}
                      className="w-100 border-0 fw-semibold"
                      style={{
                        height: "60px",
                        borderRadius: "18px",
                        background:
                          "linear-gradient(135deg, #3f80ea, #5aa9ff)",
                        fontSize: "1rem",
                        boxShadow: "0 10px 30px rgba(63,128,234,0.45)",
                        transition: "0.3s",
                      }}
                    >
                      {loading ? (
                        <>
                          <Spinner size="sm" className="me-2" />
                          Accediendo...
                        </>
                      ) : (
                        <>
                          <i className="bi bi-box-arrow-in-right me-2"></i>
                          Acceder al Sistema
                        </>
                      )}
                    </Button>
                  </Form>

                  {/* FOOTER */}
                  <div
                    className="text-center mt-5"
                    style={{
                      color: "rgba(255,255,255,0.45)",
                      fontSize: "0.9rem",
                    }}
                  >
                    © 2026 SOFTGEEK TECHNOLOGY
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ===== MODAL ===== */}
        <Modal
          isOpen={modal}
          toggle={toggleModal}
          centered
          style={{
            maxWidth: "700px",
          }}
        >
          <ModalHeader toggle={toggleModal}>
            Restaurar Contraseña
          </ModalHeader>

          <ModalBody>
            <RestoreForm />
          </ModalBody>
        </Modal>
      </div>
    </>
  );
};

export default LoginForm;
